if (!customElements.get('momo-hero-media')) {
class MomoHeroMedia extends HTMLElement {
    connectedCallback() {
        this.videos = [...this.querySelectorAll('video')];
        this.mobile = window.matchMedia('(max-width: 749px)');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.visible = !('IntersectionObserver' in window);
        this.updateMedia = this.updateMedia.bind(this);
        this.mobile.addEventListener('change', this.updateMedia);
        this.reducedMotion.addEventListener('change', this.updateMedia);
        document.addEventListener('visibilitychange', this.updateMedia);
        this.events = new AbortController();
        this.videos.forEach(video => {
            video.addEventListener('error', () => video.classList.remove('is-selected'), { signal: this.events.signal });
        });
        const front = this.querySelector('.momo-hero__video--desktop');
        const back = this.querySelector('.momo-hero__video-backdrop');
        if (front && back) {
            front.addEventListener('timeupdate', () => {
                if (!front.paused && !back.paused && Math.abs(back.currentTime - front.currentTime) > 0.1) {
                    back.currentTime = front.currentTime;
                }
            }, { signal: this.events.signal });
        }
        if ('IntersectionObserver' in window) {
            this.observer = new IntersectionObserver(entries => {
                this.visible = entries[0].isIntersecting;
                this.updateMedia();
            });
            this.observer.observe(this);
        }
        this.updateMedia();
    }

    updateMedia() {
        this.videos.forEach(video => {
            const mobileVideo = video.classList.contains('momo-hero__video--mobile');
            const selected = this.mobile.matches === mobileVideo && !this.reducedMotion.matches;
            if (!selected) {
                video.pause();
                video.classList.remove('is-selected');
                if (video.hasAttribute('src')) {
                    video.removeAttribute('src');
                    video.load();
                }
                return;
            }
            if (!this.visible || document.hidden) {
                video.pause();
                return;
            }
            video.classList.add('is-selected');
            if (video.dataset.poster) video.poster = video.dataset.poster;
            if (!video.hasAttribute('src')) video.src = video.dataset.src;
            video.muted = true;
            video.play().catch(() => { /* Keep the poster if playback is unavailable. */ });
        });
    }

    disconnectedCallback() {
        this.observer?.disconnect();
        this.events?.abort();
        this.mobile.removeEventListener('change', this.updateMedia);
        this.reducedMotion.removeEventListener('change', this.updateMedia);
        document.removeEventListener('visibilitychange', this.updateMedia);
        this.videos.forEach(video => video.pause());
    }
}

customElements.define('momo-hero-media', MomoHeroMedia);
}
